import config from '@plone/registry';
import { Tags } from '@redturtle/qubicaamf-theme/components/commons/Tags/Tags';
import SlotRenderer from '@plone/volto/components/theme/SlotRenderer/SlotRenderer';
import { useSlotContentIsLoaded } from '@redturtle/qubicaamf-theme/helpers/hooks/useContentIsLoaded.hook';
import type { TestimonialOrNews } from '@redturtle/qubicaamf-theme/components/View/NewsTestimonialsView/NewsTestimonialView';
import styles from './styles.module.css';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

const BlogCategories = (
  props: React.ComponentProps<typeof SlotRenderer> & {
    content: TestimonialOrNews;
  },
) => {
  const { content } = props;
  const contentLoaded = useSlotContentIsLoaded(props.content);
  const Container = config.getComponent('Container').component || 'div';
  return contentLoaded ? (
    <Container className={styles.blogCategoriesContainer}>
      <Tags
        ariaLabel="Blog Categories"
        items={content?.blog_tags?.map((tag) => ({
          tagName: tag,
          id: tag,
          openLinkInNewTab: false,
          cameFrom: flattenToAppURL(content['@id']),
        }))}
      />
    </Container>
  ) : null;
};

export { BlogCategories };
